import React, { useState, useEffect } from "react";
import Tabs from "./Tabs";
import TwoCompoentColSkeleton from "../skeleton/TwoCompoentColSkeleton";
import StoryWithImage from "../cards/StoryWithImage";
import { CardItem } from "../cards/HeadlineCard";
import { Link } from "@quintype/components";
import { getSectionsByFilter } from "../utils/api";

const StoryList = ({ stories }) => {
  return (
    <div className="grid w-[50%] grid-cols-2 grid-rows-2">
      {stories.map((story, index) => {
        return index === 0 ? (
          <div className="row-span-2 p-2" key={index}>
            <StoryWithImage story={story} />
          </div>
        ) : (
          <div className="row-span-1 p-2" key={index}>
            <CardItem story={story} index={index} />
          </div>
        );
      })}
    </div>
  );
};

function TwoComponentCol({ data }) {
  const [isLoading, setIsLoading] = useState(true);
  const [stateCol, setStateCol] = useState([]);
  const [active, setActive] = useState("karnataka");

  // async function fetchData() {
  //   setIsLoading(true);

  //   const stateData = await getSectionsByFilter(active);
  //   if (!stateData || stateData.length === 0) {
  //     return setIsLoading(true);
  //   }
  //   setStateCol([stateData.slice(0, 3), stateData.slice(3, 6)]);
  //   setIsLoading(false);
  // }

  useEffect(() => {
    // fetchData();
    let isMounted = true;
    async function fetchData() {
      setIsLoading(true);

      try {
        if (active == "karnataka") {
          const filterData = (name) => {
            let filterData = data.filter((item) => item.name === name);
            return filterData[0].items;
          };
          const stateData = await filterData("Karnataka").slice(0, 8);
          setStateCol([stateData.slice(0, 3), stateData.slice(3, 6)]);
          setIsLoading(false);
        } else {
          const stateData = await getSectionsByFilter(active);
          if (isMounted) {
            if (!stateData || stateData.length === 0) {
              setIsLoading(true);
            } else {
              setStateCol([stateData.slice(0, 3), stateData.slice(3, 6)]);
              setIsLoading(false);
            }
          }
        }
      } catch (error) {
        if (isMounted) {
          console.error("Failed to fetch data:", error);
          setIsLoading(false);
        }
      }
    }

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [active]);

  const listStates = [
    { name: "Karnataka", value: "karnataka" },
    { name: "Maharashtra", value: "maharashtra" },
    { name: "Bihar", value: "bihar" },
    { name: "Tamil Nadu", value: "tamil-nadu" },
    { name: "Uttar Pradesh", value: "uttar-pradesh" },
  ];

  return (
    <div className="mobile:hidden">
      <span className="flex items-center">
        <span className="h-px flex-1 bg-gray-300"></span>
        <span className="shrink-0 px-6">
          <Link href={`/section/states`}>
            <span className="text-xl font-medium text-[#ca4242]">States</span>
          </Link>
        </span>
        <span className="h-px flex-1 bg-gray-300"></span>
      </span>

      <Tabs listStates={listStates} active={active} setActive={setActive} />
      {isLoading && (
        <div className="mt-3">
          <TwoCompoentColSkeleton />
        </div>
      )}

      <div className="mt-6 flex">
        {!isLoading &&
          stateCol.map((splited, i) => (
            <div className="grid w-[50%] grid-cols-2 grid-rows-2" key={i}>
              {splited.map((story, index) => {
                return index === 0 ? (
                  <div className="row-span-2 p-2" key={index}>
                    <StoryWithImage story={story} />
                  </div>
                ) : (
                  <div className="row-span-1 p-2" key={index}>
                    <CardItem story={story} index={index} />
                  </div>
                );
              })}
            </div>
          ))}
      </div>
    </div>
  );
}

export default TwoComponentCol;
